import React from 'react';
// import {
// 	Route,
// 	Link
// } from 'react-router-dom';
import './examples.scss';
import { Carousel } from 'antd';
// import ajax from '@/api/public';

class Resource extends React.Component{
	constructor (props) {
		super(props)
		this.state={

		}
	}
    componentDidMount (){
        document.getElementById('app').scrollIntoView(true)
    }
	render() {
		return(
			<div className='weidai'>
				<div className='common-head home-contain'>
					<a href='#/customer' className="mianbaoxie">客户案例</a> <i className='glyphicon glyphicon-toright'></i> <span>贪玩游戏</span>
				</div>
				<div className='common-title' style={{marginBottom: '24px'}}>强付费能力诠释用户优质属性 手游成本屡创新低</div>
				<div className='home-contain'>
					<div className='text-center' style={{position: 'relative'}}>
						<img className='mobile-img' src={`${process.env.PUBLIC_URL}/images/mobile-border.png`} />
						<img style={{position: 'absolute', left: '509px', top: '38px'}} src={`${process.env.PUBLIC_URL}/images/360web.png`} />
						<img style={{position: 'absolute', left: '424px', top: '84px'}} src={`${process.env.PUBLIC_URL}/images/webshow.png`} />
					</div>
				</div>
				<div className='common-title home-contain'>效果展示</div>
				<div className='home-contain text-contain' style={{paddingBottom: '33px'}}>
					<span className='special'>投放方案：</span>
					<span>采用在头部自制内容播放关联的方式，通过多点定向，精准触达年轻、具备高消费能力的目标受众</span>
					<span className='special'>效果转化：</span>
					<span>投放后，大幅降低了新增用户的获取成本，实现了用户量级的稳定增长，且爱奇艺平台转化用户的付费能力普遍很强</span>
					<span className='special'>客户评价：</span>
					<span className='special'>爱奇艺用户与我们的用户匹配度高，因此我们尝试接入了这个渠道。爱奇艺团队非常专业，协助我们锁定了爱奇艺2016年头部自制内容《余罪》，在视频</span>
					<span className='special'>播放关联页进行了精准、快速的广告推送；同时在播放页面做了一目了然的“下载”按钮，这种直接的吸引方式，给我们带来了惊喜，使我们看到了细分平</span>
					<span>台对安装转化的大幅提升，现在每当有新产品上线，我们都会优先考虑在爱奇艺上进行投放。</span>
				</div>
			</div>
		)
	}
}
export default Resource;



// WEBPACK FOOTER //
// ./src/components/examples/360web.jsx